import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken } from '../utils/auth'
import { login, getInfo, logout } from '../api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken() || '',
    userInfo: {},
    permissions: [],
    roles: []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    }
  },
  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        login(credentials).then(res => {
          const data = res.data
          const tokenValue = data.tokenValue
          setToken(tokenValue)
          commit('SET_TOKEN', tokenValue)
          resolve(res)
        }).catch(reject)
      })
    },
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const data = res.data
          commit('SET_USER_INFO', data || {})
          commit('SET_PERMISSIONS', [])
          commit('SET_ROLES', [])
          resolve(res)
        }).catch(reject)
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', {})
          commit('SET_PERMISSIONS', [])
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(() => {
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', {})
          commit('SET_PERMISSIONS', [])
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        })
      })
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    permissions: state => state.permissions,
    roles: state => state.roles
  }
})
